import { useCallback, useMemo, useState } from "react";
import { IconButton } from "@mui/material";
import { MdStar, MdStarBorder } from "react-icons/md";
import { useSelector } from "react-redux";
import { FavoriteAptDialog } from "./favorite-apt-dialog";

/**
 * 관심아파트 별표 버튼.
 * - aptId만 주어지면 다이얼로그에서 평형 dropdown으로 선택
 * - pyeongId까지 주어지면 그 평형으로 바로 다이얼로그 진입
 *
 * 평형 선택 UI는 FavoriteAptDialog 내부에서 처리한다 (별표 옆에 별도 dropdown 두지 않음).
 *
 * @param {string} aptId
 * @param {string} [pyeongId] - 있으면 다이얼로그에 그대로 전달
 * @param {string} [aptName]
 * @param {number} [supplyPyeong] - pyeongId가 있을 때 표시용
 * @param {number} [iconSize]
 */
export const FavoriteAptStarButton = ({
  aptId,
  pyeongId,
  aptName,
  supplyPyeong,
  iconSize = 14,
}) => {
  const aptGroups = useSelector((state) => state.group.aptGroups || []);
  const [open, setOpen] = useState(false);

  // pyeongId가 명시되면 그 평형이 어느 그룹에든 있으면 노란색.
  // pyeongId가 없으면(단지만 알고 평형 모를 때) 색 판정 불가 → 회색.
  const isFavorite = useMemo(() => {
    if (!pyeongId) return false;
    return aptGroups.some((g) => (g.selectedApts || []).includes(pyeongId));
  }, [aptGroups, pyeongId]);

  const handleClick = useCallback((e) => {
    e.stopPropagation();
    setOpen(true);
  }, []);

  if (!aptId) return null;

  return (
    <>
      <IconButton
        size="small"
        sx={{ p: 0.2 }}
        onClick={handleClick}
        title={isFavorite ? "관심아파트에 등록됨" : "관심아파트 등록"}
      >
        {isFavorite
          ? <MdStar size={iconSize} color="#FFB400" />
          : <MdStarBorder size={iconSize} color="#999" />}
      </IconButton>
      <FavoriteAptDialog
        open={open}
        onClose={() => setOpen(false)}
        aptId={aptId}
        pyeongId={pyeongId}
        aptName={aptName}
        supplyPyeong={supplyPyeong}
      />
    </>
  );
};
